import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  Spinner,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';

import { CmLoading, CmText } from '@/components/uiParts';

import { LoadingMask } from './LoadingMask';

interface Props {
  heading?: string;
}

export const CmLongLoading: React.VFC<Props> = ({ heading = '通信中です' }) => {
  const [isLong, setIsLong] = useState<boolean>(false);
  const cancelRef =
    useRef<HTMLElement>() as React.MutableRefObject<HTMLElement>;

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLong(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  if (!isLong) return <CmLoading />;

  return (
    <AlertDialog
      isCentered
      isOpen={true}
      onClose={() => {
        // do nothing
      }}
      leastDestructiveRef={cancelRef}
      closeOnOverlayClick={false}
    >
      <LoadingMask>
        {/*
         // @ts-ignore TS2590 */}
        <AlertDialogContent pb={3}>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {heading}
          </AlertDialogHeader>

          <AlertDialogBody>
            <CmText>この処理は時間がかかる可能性があります。</CmText>
            <CmText>処理完了までしばらくお待ちください。</CmText>
          </AlertDialogBody>

          <AlertDialogFooter justifyContent="center">
            <Spinner emptyColor="gray.200" color="gray.700" />
          </AlertDialogFooter>
        </AlertDialogContent>
      </LoadingMask>
    </AlertDialog>
  );
};
